module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/$.is-object.js
// module id = 59
// module chunks = 174 178 179 182 193 194 195